import styled from "styled-components"

// Component
import SignUpPage from "./SignUpPage"

const StyledSignUpPage = styled(SignUpPage)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
` as any

export default StyledSignUpPage;